import React from "react";

import ImgPm from "../assets/img/PM 100px.png";
import ImgBm from "../assets/img/CB 100px.png";
import ImgPc from "../assets/img/icon-pc2.png";
import ImgDetran from "../assets/img/icon-detran.png";
import ImgPolCientifica from "../assets/img/icon-policia-cientifica.png";
import IconGov from "../assets/img/Brasão Alagoas 100px.png";
// import IconGovALSEPLAG from "../assets/img/SEPLAG Gov.png";
import IconGovALSSP from "../assets/img/SSP governo.png";

const Footer = (props) => {
  return (
    <footer className="py-3 bg-dark footerFixed">
      <div className="footer m-0 text-center text-white footerF">
        <a href="http://www.governo.al.gov.br/" target="blank" title="Governo do estado de ALAGOAS">
          <img src={IconGov} alt="" />
        </a>
        <a href="http://pm.al.gov.br" target="blank" title="Polícia Militar - AL">
          <img src={ImgPm} alt="" />
        </a>
        <a href="http://pc.al.gov.br" target="blank" title="Polícia Civil - AL">
          <img src={ImgPc} alt="" />
        </a>
        <a href="http://cbm.al.gov.br/" target="blank" title="Bombeiro - AL">
          <img src={ImgBm} alt="" />
        </a>
        <a href="http://www.periciaoficial.al.gov.br/" target="blank" title="Perícia Oficial - AL">
          <img src={ImgPolCientifica} alt="" />
        </a>
        <a href="https://www.detran.al.gov.br/" target="blank" title="Detran - AL">
          <img src={ImgDetran} alt="" />
        </a>
        {/* <a href="http://seguranca.al.gov.br/" target="blank" title="SSP">
          <img src={IconGovALSSP} alt="" />
        </a> */}
        {/* <a href="http://www.seplag.al.gov.br/" target="blank" title="SEPLAG">
					<img src={IconGovALSEPLAG} alt="" />
				</a> */}
      </div>
      <div className="container mt-3">
        <div className="row text-white">
          <div className="col-12 col-sm-6 col-md-6 text-center text-sm-left">
            <p>
              Copyright &copy; 2018 <br />
              Todos os Direitos Reservados
            </p>
          </div>
          <div className="col-12 col-sm-6 col-md-6 text-center text-sm-right">
            <p>
              Desenvolvido por TI/SSP AL <br />
              Versão {process.env.REACT_APP_VERSION}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js